import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import { ContactDataPageComponent } from './contact-data-page/contact-data-page.component';

export const contactDataRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {
        path: 'list',
        component: ContactDataPageComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(contactDataRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class ContactDataRoutingModule {
}
